import "./LetsTalk.module.css";
import Header from "@/reusable_sections/Header";
import HeroCallToAction from "./sections/HeroCallToAction";
import GetInTouch from "./sections/GetInTouch";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function LetsTalkPage() {
  return <div>
      <Header />
      <HeroCallToAction />
      <GetInTouch />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}